import { IStore } from '../../store';
import { jobSelectors } from '../../_core/job';
import {
    IBallastStore,
} from './@types';
import { EBallastActions } from './actions';

const ballastSelectors = {
    _getStore(store: IStore) {
        return store.app.ballast;
    },
    getHistoryList(store: IBallastStore) {
        return store.records.ids.map((id) => ({
            ...store.records.byIds[id],
        }));
    },
    getFilter(store: IBallastStore) {
        return {
            ...store.filters,
            shownRecords: store.filters.shownRecords
                ? store.filters.shownRecords
                : 'ALL',
        };
    },
	getTableLogs(store: IBallastStore) {
        return store.tableLogs;
    },
	getBallastTanks(store: IBallastStore) {
        return store.ballastTanks;
    },
	getSelectedBallastTankForTableLogs(store: IBallastStore) {
        return store.selectedBallastTankForTableLogs;
    },
    jobToLoadHistory(store: IBallastStore) {
        return jobSelectors.getJobStatus(store, EBallastActions.HISTORY_LOAD);
    },
	jobToLoadTableLogs(store: IBallastStore) {
        return jobSelectors.getJobStatus(
            store,
            EBallastActions.TABLE_LOGS_LOAD
        );
    },
};
export default ballastSelectors;
